import { BaseTLDetailComponent, AxiosResponse, RightHelper, Watch,StatisticsService, StatisticsFilter, TenantService, TenantFilter, tlStore, tlISODateToLocalString } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class StatisticsDetailBase extends BaseTLDetailComponent {

	returnRoute: string = "StatisticsDetail";
	statisticsService = new StatisticsService();
	tenantService = new TenantService();

	selectedTenant = '';

	//1-minuly mesic, 2 - aktualni mesic 3 - měsíce, 4 - rok, 5 - období
	selectedPeriod = '1';
	periods: any[] = [];

	//1-den, 2 - tyden 3 - měsíc, 4 - rok
	selectedPeriodRange = '1';
	periodsRange: any[] = [];


	selectedPeriodMonth = '';
	periodsMonth: any[] = [];

	items: any[] = [];
	tenants: any[] = [];
	items2: any[] = [];

	name = "test";

	formData = {
		validFrom: '',
		validTo: '',
	};

	grafLabel: string[] = [];
	grafCount: number[] = [];
	grafDisk: number[] = [];
	grafPriority: number[] = [];

	fieldsStatics = [
		//{ key: 'id', label: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
		{ key: 'startDate', label: this.$t('statistics.fieldDate'), trans: 'statistics.fieldDate', sortable: true, class: 'text-center', formatter: (x: Date) => tlISODateToLocalString(x) },
		{ key: 'receiverActiveCount', label: this.$t('statistics.fieldCount'), trans: 'statistics.fieldCount', sortable: true, class: 'text-center' },
		{ key: 'userDiscSpace', label: this.$t('statistics.fieldDisk'), trans: 'statistics.fieldDisk', sortable: true, class: 'text-center' },
		{ key: 'priorityQueueEnabledText', label: this.$t('statistics.fieldPriority'), trans: 'statistics.fieldPriority', sortable: true, class: 'text-center' },

	];

	lastWatch = '';
	lastPeriodType = '';
	lastPeriodRange = '';
	lastDateFrom = '';
	lastDateTo = '';

	@Watch('formData.validFrom')
	changeDateFrom(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastDateFrom != value) {
			this.lastDateFrom = value;
			oldValue = value;
			this.loadStatistics();
		}
	}

	@Watch('formData.validTo')
	changeDateTo(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastDateTo != value) {
			this.lastDateTo = value;
			oldValue = value;
			this.loadStatistics();
		}
	}

	@Watch('selectedPeriodRange')
	changePeriodRange(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastPeriodRange != value) {
			this.lastPeriodRange = value;
			oldValue = value;
			this.loadStatistics();
		}
	}

	@Watch('selectedPeriod')
	changePeriodType(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastPeriodType != value) {
			
			this.lastPeriodType = value;
			oldValue = value;
			this.initPeriodRange();
			this.loadStatistics();
		}
	}


	@Watch('selectedPeriodMonth')
	changePeriodMonth(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastWatch != value) {
			this.lastWatch = value;
			oldValue = value;
			this.loadStatistics();
		}
	}
	lastWatchTenant = '';
	@Watch('selectedTenant')
	changeselectedTenant(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '' && value != '' && this.lastWatchTenant != value) {
			this.lastWatchTenant = value;
			oldValue = value;
			this.loadStatistics();
		}
	}

	loadTenants() {
		var filter = new TenantFilter(false);
		this.tenantService.getAllByFilter(filter).then(res => {

			this.initPeriod();
			this.initPeriodRange();

			this.items2 = res.data;
			for (var i = 0; i < this.items2.length; i++) {
				if (this.tenants.filter((c: any) => c.value == this.items2[i].id).length == 0) {
					this.tenants.push({ value: this.items2[i].id, text: this.items2[i].name, description: this.items2[i].name });
				}
			}
			this.tenants = this.tenants.sort((a, b) => a.text.localeCompare(b.text));
			this.selectedTenant = tlStore.state.idTenant.toString();


			//dopln to 
			let aktualniROk: number = new Date().getFullYear();
			let aktualniMesic: number = new Date().getMonth() + 1;
			this.periodsMonth = [];
			this.grafLabel = [];

			for (var i = 0; i < 12; i++) {
				this.addPeriod(aktualniROk, aktualniMesic);
				aktualniMesic = aktualniMesic - 1;
				if (aktualniMesic < 1) {
					aktualniMesic = 12;
					aktualniROk = aktualniROk - 1;
				}
			}
			this.selectedPeriodMonth = this.periodsMonth[0].value;

			this.loadStatistics();
		});

	}

	initPeriod() {
		this.periods.push({ value: "1", text: this.$t('statistics.periodLastMonth') });
		this.periods.push({ value: "2", text: this.$t('statistics.periodActualMonth') });
		this.periods.push({ value: "3", text: this.$t('statistics.periodMonth') });
		this.periods.push({ value: "4", text: this.$t('statistics.periodYear') });
		this.periods.push({ value: "5", text: this.$t('statistics.periodFromTo') });
	}

	initPeriodRange() {
		this.periodsRange = [];
		if (this.selectedPeriod != "4") { //rok nema sumacni období dnu
			this.periodsRange.push({ value: "1", text: this.$t('statistics.periodRangeDay') });
		}
		this.periodsRange.push({ value: "2", text: this.$t('statistics.periodRangeWeek') });
		this.periodsRange.push({ value: "3", text: this.$t('statistics.periodRangeMonth') });

	
		if (this.selectedPeriod == "4" || this.selectedPeriod == "5") {
			this.periodsRange.push({ value: "4", text: this.$t('statistics.periodRangeYear') });
			if (this.selectedPeriodRange == "1") {
				this.selectedPeriodRange = "2";
			}
		}
		else {
			if (this.selectedPeriodRange == "4") {
				this.selectedPeriodRange = "3";
			}
		}
	}


	renderChartCount() {
		//@ts-ignore
		const ctxBar = this.$refs.chartCanvasBarCount.getContext('2d');
		//@ts-ignore
		new Chart(ctxBar, {
			type: 'bar',
			data: {
				labels: this.grafLabel,
				datasets: [
					{
						label: this.$t('statistics.countReceiver').toString(),
						data: this.grafCount,
						backgroundColor: 'rgba(255, 180, 132, 1)',
						borderWidth: 2
					}
				]
			},
			options: {
				animation: {
					duration: 0 // Disable animations
				},
				tooltips: {
					enabled: false // Disable tooltips
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true, // Start y-axis at 0
							precision: 0 // Disable decimal places on y-axis labels
						}
					}]
				},
				events: [] // Disable all mouse events
			}
		});
	}

	renderChartDisk() {
		//@ts-ignore
		const ctxBar = this.$refs.chartCanvasBarDisk.getContext('2d');
		//@ts-ignore
		new Chart(ctxBar, {
			type: 'bar',
			data: {
				labels: this.grafLabel,
				datasets: [
					{
						label: this.$t('statistics.diskSpace').toString(),
						data: this.grafDisk,
						backgroundColor: 'rgba(210, 180, 132, 1)',
						borderWidth: 2
					}
				]
			},
			options: {
				animation: {
					duration: 0 // Disable animations
				},
				tooltips: {
					enabled: false // Disable tooltips
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true, // Start y-axis at 0
							precision: 0 // Disable decimal places on y-axis labels
						}
					}]
				},
				events: [] // Disable all mouse events
			}
		});
	}

	yesAnswer = this.$t('statistics.answerYes').toString();
	noAnswer = this.$t('statistics.answerNo').toString();

	renderChartPriority() {
		//@ts-ignore
		const ctxBar = this.$refs.chartCanvasBarPriority.getContext('2d');
		//@ts-ignore
		new Chart(ctxBar, {
			type: 'bar',
			data: {
				labels: this.grafLabel,
				datasets: [
					{
						label: this.$t('statistics.priorityTask').toString(),
						data: this.grafPriority,
						backgroundColor: 'rgba(255, 220, 132, 1)',
						borderWidth: 2
					}
				]
			},
			options: {
				animation: {
					duration: 0 // Disable animations
				},
				tooltips: {
					enabled: true,
					callbacks: {
						label: function (tooltipItem: any, data: any) {
							//@ts-ignore
							let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
							return value === 1 ? 'Ano':'Ne';
						}
					}
				},
				scales: {
					yAxes: [{
						ticks: {
							callback: function (value:any) {
								return value === 1 ? 'Ano' : 'Ne';
							},
							stepSize: 1,
							min: 0,
							max: 1,
							padding: 10 // Add padding to the y-axis labels
						},
						gridLines: {
							drawBorder: false, // Optionally adjust the grid lines
							zeroLineWidth: 1, // Adjust the zero line width if necessary
							zeroLineColor: 'rgba(0, 0, 0, 0.1)' // Adjust the zero line color if necessary
						},
						scaleLabel: {
							display: true,
							labelString: this.$t('statistics.onSelected').toString(),// Add a label to the y-axis if necessary
							padding: {
								top: 10,
								bottom: 10
							}
						}
					}]
				},
				events: [] // Disable all mouse events
			}
		});
	}






	loadStatistics() {
		let filter: StatisticsFilter = new StatisticsFilter(Number(this.selectedTenant), this.selectedPeriod, this.selectedPeriodRange, this.selectedPeriodMonth, this.formData.validFrom, this.formData.validTo);
        this.statisticsService.getAllByFilter(filter).then(res => {
            this.items = res.data;
            this.grafCount = [];
            this.grafDisk = [];
            this.grafPriority = [];

            this.grafLabel = this.items[0].daysLabel;
            this.grafLabel.push();
            for (var i = 0; i < this.items.length; i++) {
                this.grafCount.push(this.items[i].receiverActiveCount);
                this.grafDisk.push(this.items[i].userDiscSpace);
                this.grafPriority.push(this.items[i].priorityQueueEnabled?1:0);
			}
			this.renderChartCount();
			this.renderChartDisk();
			this.renderChartPriority();

        });

    }

	addPeriod(year: number, month: number) {
		var monthAdd = '';
		if (month < 10) {
			monthAdd = '0' + month;
		}
		else {
			monthAdd = month.toString();
		}

		this.periodsMonth.push({ value: year.toString() + monthAdd, text: monthAdd + '.' + year });
	}

	
	

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let filter: StatisticsFilter = new StatisticsFilter(this.$store.state.idTenant, this.selectedPeriodMonth);
		var allItems = this.statisticsService.getAllByFilter(filter);

		allItems.then(response => {
			this.items = response.data;
		});

		return allItems;
	}


	//zatím nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}


	protected prepareItems(items: any[]) {
	};

	createdBase() {
		this.loadTenants();
		this.formData.validFrom = this.formatDate(this.getDateMinusDays(30));
		this.formData.validTo = this.formatDate(new Date());
	}

	formatDate(date: Date): string {
		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Měsíc začíná od 0, proto přidáváme 1
		const day = date.getDate().toString().padStart(2, '0');
		return `${year}-${month}-${day}`;
	}
	getDateMinusDays(days: number): Date {
		const date = new Date();
		date.setDate(date.getDate() - days);
		return date;
	}
}
